import PropTypes from 'prop-types';
import React from 'react';
import DatePicker from 'react-datepicker';

import BaseInput from 'components/atomic/controls/BaseInput';

const MonthInput = ({ name, placeholder, disabled, value, minDate, maxDate, onBlur, onChange, ...restProps }) => {
  const handleChange = (date) => {
    onChange && onChange({ target: { name, value: date } });
  };

  return (
    <DatePicker
      closeOnScroll
      showMonthYearPicker
      popperPlacement="top"
      disabled={disabled}
      placeholderText={placeholder}
      dateFormat="MMMM, yyyy"
      minDate={minDate}
      maxDate={maxDate}
      selected={value}
      onChange={handleChange}
      onBlur={onBlur}
      customInput={<BaseInput name={name} {...restProps} />}
    />
  );
};

MonthInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.object,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default MonthInput;
